import { render, staticRenderFns } from "./storeTongueQrCode.vue?vue&type=template&id=433f9170&scoped=true&"
import script from "./storeTongueQrCode.vue?vue&type=script&lang=ts&"
export * from "./storeTongueQrCode.vue?vue&type=script&lang=ts&"
import style0 from "./storeTongueQrCode.vue?vue&type=style&index=0&id=433f9170&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433f9170",
  null
  
)

export default component.exports